import React, { useState, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { flowRight, get, isEmpty, find, forEach, omit } from 'lodash';
import { withRouter } from 'react-router';
import cn from 'classnames';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import Button from 'chameleon/ui-stack/ui/base/button';
import IconWithDescription from 'legacy-src/utility/IconWithDescription';

import useAssessmentPreview from 'legacy-src/components/assessment/hooks/useAssessmentPreview';

// -- Question Bank
import { getQuestionStimulus } from 'legacy-src/components/questionBank/QuizBuilder/utils';
import ItemTitleWithIcons from 'legacy-src/components/questionBank/ItemTitleWithIcons';
import DeleteQuestionModal from 'legacy-src/components/questionBank/QuizBuilder/components/DeleteQuestionModal';
import useQuizBuilderActions from 'legacy-src/components/questionBank/QuizBuilder/hooks/useQuizBuilderActions';
import EditQuestionModal from 'legacy/src/components/questionBank/QuizBuilder/components/QuestionsItemPreview/EditQuestionModal';
import QuizDataProvider from 'legacy-src/components/questionBank/QuizBuilder/components/QuizDataProvider';

// -- Constants
import { authoringPath } from 'legacy-src/constants/paths';
import { ASSESSMENT_BUTTONS } from 'legacy-src/constants/assessmentPreviewButtons';

// Legacy utilities
import {
  SecureInfoIcon,
  StudentPracticeIcon,
  APTopicQuestionIcon,
} from 'legacy-src/utility';
import EditOptions from 'legacy-src/utility/AssessmentActions/actions/EditOptions';
import RetiredItemIcon from 'legacy-src/utility/IconWithDescription/RetiredItemIcon';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import { isFRQ, isMCQ } from 'legacy-src/utility/progressHelpers';

import ScreenModal from 'chameleon/ui-stack/ui/modals/screen-modal';
import PreviewItem from 'legacy-src/utility/PreviewItem';

import { IsQuestionEditable } from 'legacy-src/components/questionBank/helpers';

import AssessmentActions from './AssessmentActions';
import Icon from 'chameleon/ui-stack/ui/base/icon';

import 'legacy-src/components/assessment/Preview.scss';
import './styles.scss';
import { parseNonEmptyJSONObject } from 'legacy-src/utility/utils';
import { withAssessmentInfo } from 'chameleon/ui-stack/hocs/player';
import TeacherRemovedQuestionIcon from 'legacy-src/utility/IconWithDescription/TeacherRemovedQuestionIcon';

const Preview = ({
  isPreApSubject = false,
  featureFlag: {
    show_student_practice_icon: showStudentPracticeIconFF,
    show_attestation_confirmation_dialog: showAttestationFF,
    copy_assessments: isCopyAssessmentsEnabled,
    reorder_questions: canReorderQuestionsFlag,
    edit_question_assessment: editQuestionAssessmentFlag,
    edit_existing_question: editExistingQuestion,
    edit_existing_question_frq: editExistingQuestionFrq,
    edit_cb_provided_question: editCbProvidedQuestion,
    copy_question_assessment: copyQuestionAssessmentFlag,
    retire_qb_questions: retireQbQuestionsFF,
  },
  masterSubjectId = null,
  subjectInitId = null,
  isAdminOrCoordinator = false,
  groups = [],
  onPreviewTabChanged = () => {},
  onQuestionChanged = () => {},
  closePreviewLink = '/',
  firstQuestion = {},
  previewId = null,
  router = {},
  currentItem = {},
  loadingCurrentItem,
  me = {},
  onAssign = () => {},
  chosenEducationPeriodCode,
  subjectInfo = {},
  renderSharedAssessmentActions,
  isComingfromSharedAssessmentPage,
  sharedAssessmentInfo,
  enableSharedAssessments,
  blueBookUiFlag,
}) => {
  const previewEditMode = 'previewEditMode';
  const newQuestionItemId = 'newQuestionItemId';
  const previewEditModeTrue = 'true';

  // Can not put function to setState directly.
  const [reloadLearnosity, setReloadLearnosity] = useState({ cb: null });
  const [currentQuestion, setCurrentQuestion] = useState(firstQuestion);
  const [showDeleteQuestionConfirm, setShowDeleteQuestionConfirm] =
    useState(false);
  const [openEditOptionsModal, setOpenEditOptionsModal] = useState(false);
  const [openDeleteOptionsModal, setOpenDeleteOptionsModal] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isReordering, setIsReordering] = useState(false);
  const [showConfirmFromReordering, setShowConfirmFromReordering] =
    useState(false);
  const [openEditQuestionModal, setOpenEditQuestionsModal] = useState(null);
  const [isEditModeOn, setIsEditModeOn] = useState(
    get(router, ['location', 'query', previewEditMode], '') ===
      previewEditModeTrue,
  );
  const [isQuizChanged, setIsQuizChanged] = useState(false);

  const {
    deleteItem,
    moveItem,
    save,
    rollback,
    questions = [],
    state = {},
    isLoading: isSaving,
  } = useQuizBuilderActions();

  const {
    location,
    goTo,
    replaceParamsInLocation,
    pushParamsToHistory,
    isAssignmentsPage,
  } = useNavigation({
    router,
  });

  const query = get(router, ['location', 'query'], {});
  const searchParams = get(router, ['location', 'search'], '');
  const pathname = get(router, ['location', 'pathname'], '');
  const {
    buttons,
    getVisibleButtons,
    // checkIfBQ, TODO: Keep this for future. More details in FY-21466.
    returnPath,
  } = useAssessmentPreview({ isPreApSubject, query });

  const visibleButtons = getVisibleButtons(currentItem);
  const editPreviewLink = `/${masterSubjectId}/question_bank/create?editMode=true&quizId=${previewId}`;
  const { isTeacherAuthored, itemShareChain, itemId } = currentQuestion;
  // If the itemId is not the first item on the itemShareChain, the question comes from a share, then the user is not the real author
  const isRootItem =
    !!itemShareChain &&
    itemShareChain.split('/').filter((elem) => !!elem)[0] === itemId;
  const isCurrentQuestionOwner = !itemShareChain
    ? parseInt(currentQuestion.owner_id, 10) === parseInt(me.initId, 10)
    : isRootItem;

  // before actually loading learnosity or doing other things (show attestation dialog) understand if
  // assessment has attribute which allow us to do so (e.g. isPracticeExam, isSampleQuiz etc..)
  if (loadingCurrentItem) return null;

  const getVisibleActions = () => {
    let actions = {};
    forEach(buttons, (button) => {
      let isVisible = visibleButtons.includes(button);
      if (button === ASSESSMENT_BUTTONS.copy) {
        /** Must be moved inside getVisibleButtons()*/
        isVisible = isVisible && isCopyAssessmentsEnabled;
      }
      actions[button] = isVisible;
    });

    return actions;
  };

  const removeCurrentQuestion = async () => {
    setShowDeleteQuestionConfirm(false);
    const question = questions[currentQuestion.itemId];
    // due to how deleteItem is implemented question should have stimulusId
    // we need to add it dynamically because question can be added/removed by user
    const stimulusId = Object.keys(state.stimulusQuestionsInQuiz).find((id) =>
      state.stimulusQuestionsInQuiz[id].includes(question.id),
    );
    const myQuiz = await deleteItem({
      ...currentQuestion,
      id: parseInt(currentQuestion.itemId, 10),
      stimulusId: parseInt(stimulusId, 10),
    });

    // based on conversation with Nuri, IF after deleting no questions left
    // DONT save this assessments, e.g. don't save quiz with 0 questions
    if (myQuiz.length > 0) {
      await save(previewId, currentItem.title);
      setIsQuizChanged(true);
    }
    await reloadLearnosity.cb();
  };

  const previewItem = () => (
    <PreviewItem
      blueBookUiFlag={blueBookUiFlag}
      subjectId={subjectInitId}
      isReordering={isReordering}
      onOrderChange={(from, to, reference) => {
        const movedQuestion = find(
          state.questions,
          (o) => o.learnosity_item_reference === reference,
        );
        const hasFullSetMoved = !movedQuestion && Array.isArray(reference);
        const stimulus = hasFullSetMoved
          ? null
          : getQuestionStimulus(movedQuestion, state.stimulusQuestionsInQuiz);
        moveItem(from, to, stimulus && stimulus.id);
      }}
      itemId={previewId}
      onQuestionChanged={(question) => {
        setCurrentQuestion(question);
        onQuestionChanged(question);
      }}
      onItemLoad={(item, refetch) => {
        setReloadLearnosity({ cb: refetch });
      }}
      getCurrentQuestionIndex={setCurrentQuestionIndex}
    />
  );

  const goToEdit = () => router.push(editPreviewLink);

  const goToDelete = () => {
    setOpenDeleteOptionsModal(false);
    setShowDeleteQuestionConfirm(true);
  };

  const deleteClicked = () => {
    setShowDeleteQuestionConfirm(true);
  };

  const saveOrder = async () => {
    await save(previewId, currentItem.title);
    setIsQuizChanged(true);
    setShowConfirmFromReordering(null);
    if (showConfirmFromReordering === 'FROM_CLOSE') {
      setIsReordering(false);
      return router.push(returnPath || closePreviewLink);
    }
    await reloadLearnosity.cb();
  };

  const resetReordering = () => {
    setIsReordering(false);
    setShowConfirmFromReordering(null);
    rollback();

    if (showConfirmFromReordering === 'FROM_CLOSE') {
      router.push(returnPath || closePreviewLink);
    }
  };

  const { isAssigned, isInProgress } = currentItem;

  const isOwner =
    parseInt(currentQuestion.owner_id, 10) === parseInt(me.initId, 10);

  const extraQuery = {
    returnPath: `${pathname}${searchParams}&${previewEditMode}=${previewEditModeTrue}`,
  };

  if (!isOwner) extraQuery.copyItem = true;

  const editMCQ = isMCQ(currentQuestion) && editExistingQuestion;
  const editFRQ = isFRQ(currentQuestion) && editExistingQuestionFrq;
  const showEditQuestion =
    editQuestionAssessmentFlag &&
    IsQuestionEditable(isOwner, editMCQ, editFRQ, editCbProvidedQuestion);
  const showCopyQuestion =
    copyQuestionAssessmentFlag &&
    IsQuestionEditable(isOwner, editMCQ, editFRQ, editCbProvidedQuestion);

  const { subjects = [] } = subjectInfo;

  const currentSubject =
    subjects &&
    subjects.length &&
    subjects.find((s) => s.name === subjectInfo.name);

  const goToEditQuestion = (extras = {}) => {
    goTo(
      replaceParamsInLocation(
        {
          educationPeriod: chosenEducationPeriodCode,
          masterSubject: subjectInfo.id,
          subjectInfoInitId: currentSubject.initId,
          subjectInfoName: currentSubject.name,
          returnPath: `${location.pathname}${location.search}`,
          itemId: currentQuestion.itemId,
          ...extras,
        },
        authoringPath,
      ),
    );
  };

  const editQuestionClicked = () => {
    let { used_detail: usedDetail } = currentQuestion;
    usedDetail = parseNonEmptyJSONObject(usedDetail);

    if (!isOwner) {
      replaceQuestionClicked();
    } else if (isEmpty(usedDetail)) {
      goToEditQuestion(extraQuery);
    } else {
      setOpenEditQuestionsModal(true);
    }
  };

  const replaceQuestionClicked = () => {
    const locationQuery = omit(query, [newQuestionItemId, 'item']);

    locationQuery.replaceQuestion = true;
    locationQuery.returnPath = pathname;

    router.push({
      pathname: authoringPath,
      query: locationQuery,
    });
  };

  const copyQuestionClicked = () => {
    goToEditQuestion({
      copyQuestion: true,
    });
  };

  const closePreview = () => {
    let newParams = {};
    /**
     * this will tell the Assignments page to refresh because the
     * Last Modified date needs to be updated
     */
    if (isQuizChanged && isAssignmentsPage) {
      newParams.refreshAssignments = 1;
    }

    returnPath
      ? goTo(returnPath)
      : pushParamsToHistory(
          newParams,
          closePreviewLink.pathname,
          closePreviewLink.toOmit || ['quizId', 'previewEditMode', 'isPreview'],
        );
    onPreviewTabChanged(0);
  };

  const showRetiredQuestionIcon =
    currentQuestion.isRetired &&
    !currentQuestion.isTeacherAuthored &&
    !me.isStudent;
  const showTeacherRemovedQuestionIcon =
    currentQuestion.isRetired &&
    currentQuestion.isTeacherAuthored &&
    !me.isStudent &&
    retireQbQuestionsFF;

  const previewTitle = !isEmpty(currentQuestion) && (
    <Fragment>
      {isEditModeOn ? 'Edit Mode: ' : ''}
      {`Q${currentQuestionIndex + 1}: ${currentQuestion.title}`}
    </Fragment>
  );

  const previewSubTitle = (
    <div className="flex gap-4">
      <ItemTitleWithIcons
        item={currentQuestion}
        iconsMap={{
          is_secure: showAttestationFF && <SecureInfoIcon />,
          is_cb_practice_quiz: showStudentPracticeIconFF && (
            <StudentPracticeIcon isQuestion />
          ),
          is_topic_question: (
            <APTopicQuestionIcon popoverClass="lightbulb--yellow" />
          ),
        }}
      />
      {!isPreApSubject &&
        currentItem &&
        currentQuestion.title &&
        isTeacherAuthored && (
          <IconWithDescription
            className="owner_indicator cursor-pointer"
            buttonClassName="flex items-center"
            trigger={
              <Icon
                name={
                  isCurrentQuestionOwner ? 'my_question' : 'my_copied_question'
                }
                accessibility={{
                  title: isCurrentQuestionOwner
                    ? 'my authored question'
                    : 'my copied question',
                }}
                width="20"
                height="20"
              />
            }
          >
            {isCurrentQuestionOwner
              ? 'You have created this question.'
              : 'Another educator created this question. It has not been reviewed by the AP Program.'}
          </IconWithDescription>
        )}
      {showRetiredQuestionIcon && <RetiredItemIcon isQuestion />}
      {showTeacherRemovedQuestionIcon && <TeacherRemovedQuestionIcon />}
    </div>
  );

  const previewTopBar = isReordering ? (
    <div className="flex items-center gap-x-4">
      <span className="help-text">Drag and drop to reorder questions.</span>
      <Button
        isOutline
        onClick={() => {
          if (state.isDirty) {
            return setShowConfirmFromReordering(true);
          }
          setIsReordering(false);
        }}
        accessibility={{
          label: 'Return to Preview',
        }}
        className={
          blueBookUiFlag && '!text-bluebook-blue !border-bluebook-blue'
        }
      >
        Return to Preview
      </Button>
      <Button
        isPrimary
        disabled={state.isLoadingQuiz || !state.isDirty}
        onClick={saveOrder}
        accessibility={{
          label: 'Save',
        }}
        className={blueBookUiFlag && 'bg-bluebook-blue'}
      >
        Save
      </Button>
    </div>
  ) : (
    <div className="flex">
      {!isEmpty(currentItem) && (
        <AssessmentActions
          showReorderQuestions={canReorderQuestionsFlag}
          showEditQuestion={showEditQuestion}
          onReorderQuestionsClick={() => setIsReordering(true)}
          onEditQuestionClick={editQuestionClicked}
          onDeleteClick={deleteClicked}
          visibleActions={getVisibleActions()}
          assignment={{
            ...currentItem,
            assessment_id: Number.parseInt(currentItem.id, 10),
          }}
          subjectInfo={subjectInfo}
          groups={isAdminOrCoordinator ? [] : groups}
          onAssign={onAssign}
          isEditModeOn={isEditModeOn}
          setIsEditModeOn={setIsEditModeOn}
          isEditModeDataLoading={state.isLoadingQuiz}
          router={router}
          previewEditMode={previewEditMode}
          showCopyQuestion={showCopyQuestion}
          onCopyQuestionClick={copyQuestionClicked}
          newQuestionItemId={newQuestionItemId}
          isButton
          isAdminOrCoordinator={isAdminOrCoordinator}
          renderSharedAssessmentActions={renderSharedAssessmentActions}
          sharedAssessmentInfo={sharedAssessmentInfo}
          isComingfromSharedAssessmentPage={isComingfromSharedAssessmentPage}
          enableSharedAssessments={enableSharedAssessments}
          actionsTriggerClassName={blueBookUiFlag ? 'bg-bluebook-blue' : ''}
        />
      )}
    </div>
  );

  return (
    <Fragment>
      <ScreenModal
        headerWithBorder={false}
        contentWithSpacing={false}
        isScrollableContent={false}
        size="full"
        dialogClassName={cn(
          { '--is-reordering': isReordering },
          'chameleon-assessment-preview',
        )}
        wrapperClassName="overflow-hidden"
        title={previewTitle}
        subTitle={previewSubTitle}
        topBar={previewTopBar}
        topBarClassName={blueBookUiFlag ? 'min-h-28 bg-bluebook-gray8' : ''}
        onClose={() => {
          if (isReordering && state.isDirty) {
            return setShowConfirmFromReordering('FROM_CLOSE');
          }

          closePreview();
        }}
      >
        {blueBookUiFlag ? null : (
          <div className="p-6 border-b text-3xl border-gray-300 font-heading font-medium">
            {currentItem.title}
          </div>
        )}
        {previewItem()}
      </ScreenModal>

      {showDeleteQuestionConfirm && (
        <DeleteQuestionModal
          onSubmit={removeCurrentQuestion}
          onCancel={() => setShowDeleteQuestionConfirm(false)}
        />
      )}

      {openDeleteOptionsModal && (
        <EditOptions
          assessmentId={currentItem.id}
          masterSubjectId={masterSubjectId}
          isAssigned={isAssigned}
          isInProgress={isInProgress}
          onSubmit={goToDelete}
          onClose={() => setOpenDeleteOptionsModal(false)}
        />
      )}

      {openEditOptionsModal && (
        <EditOptions
          assessmentId={currentItem.id}
          masterSubjectId={masterSubjectId}
          isAssigned={isAssigned}
          isInProgress={isInProgress}
          onSubmit={goToEdit}
          onClose={() => setOpenEditOptionsModal(false)}
        />
      )}

      {openEditQuestionModal && (
        <EditQuestionModal
          item={currentQuestion}
          onSubmit={goToEditQuestion}
          onClose={() => setOpenEditQuestionsModal(false)}
        />
      )}

      {showConfirmFromReordering && (
        <ConfirmDialog
          title="Unsaved Changes"
          contentLabel="Unsaved Changes"
          onClose={() => {
            resetReordering();
            setShowConfirmFromReordering(false);
          }}
          onSuccess={async () => {
            await saveOrder();
            setShowConfirmFromReordering(false);
            setIsReordering(false);
          }}
          aria={{
            live: 'polite',
          }}
          content={{
            btnSecondary: "Don't Save",
            btnPrimary: isSaving ? 'Saving...' : 'Save',
          }}
        >
          <p>
            Do you want to save the changes you made to the order of questions
            on ${currentItem.title}?
          </p>
        </ConfirmDialog>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isPreApSubject: state.subject.data.isPreApSubject,
  me: state.userData.me,
  featureFlag: state.featureFlag,
  masterSubjectId: state.subject.data.id,
  subjectInfo: state.subject.data,
  // needed for QuizDataProvider.
  userSubjects: state.userSubjects,
  // don't remove
  chosenEducationPeriodCode: state.userData.chosenEducationPeriodCode,
  isAdminOrCoordinator: state.userData.isAdmin || state.userData.isCoordinator,
  enableSharedAssessments: state.featureFlag.shared_assessments,
  retireQbQuestionsFF: state.featureFlag.retire_qb_questions,
  blueBookUiFlag: state.featureFlag.bluebook_ui,
});

export default flowRight(
  connect(mapStateToProps),
  withAssessmentInfo,
  withApollo,
  withRouter,
  QuizDataProvider,
)(Preview);
